import { z } from 'zod'

export const projectId = z.string().min(1)
const projectName = z.string().trim().min(1).max(120)
const projectCode = z.string().trim().min(1).max(40)
export const budgetMinutes = z.number().int().min(0).max(2147483647).nullable()
const optionalCustomerId = z.string().min(1).nullable().optional()

export const createProjectInput = z.object({
  name: projectName,
  budgetMinutes: budgetMinutes.optional(),
  customerId: optionalCustomerId,
  code: projectCode.nullable().optional(),
  billable: z.boolean().optional()
})
export type CreateProjectInput = z.infer<typeof createProjectInput>

export const updateProjectInput = z
  .object({
    name: projectName.optional(),
    budgetMinutes: budgetMinutes.optional(),
    customerId: optionalCustomerId,
    code: projectCode.nullable().optional(),
    active: z.boolean().optional(),
    billable: z.boolean().optional()
  })
  .refine((input) => Object.keys(input).length > 0, {
    message: 'Provide at least one project field to update.'
  })
export type UpdateProjectInput = z.infer<typeof updateProjectInput>

export const project = z.object({
  id: projectId,
  budgetMinutes,
  customerId: z.string().min(1).nullable(),
  name: z.string().min(1),
  code: z.string().min(1).nullable(),
  active: z.boolean(),
  billable: z.boolean()
})
export type Project = z.infer<typeof project>
